import { ContactSlugEnum, CountryEnum } from '@systemeio/ui'
import { contactAdditionalFilters } from 'modules/contacts/constants/contact-filter-titles'
import {
  ContactFilterContactStateEnum,
  ContactSearchFieldEnum,
} from 'modules/contacts/enums/contact-enum'
import {
  ContactFieldApiInterface,
  ContactFilterConditionInterface,
  ContactFilterType,
} from 'modules/contacts/types/contact-filter-interface'

export const getFilter = (
  conditions: ContactFilterConditionInterface[],
  filterFields: ContactFieldApiInterface,
): ContactFilterType => {
  return conditions.reduce((obj, condition) => {
    const filterFieldItem = filterFields.items.find(
      el => el.id.toString() === condition.searchField,
    )
    if (filterFieldItem) {
      switch (filterFieldItem.slug) {
        case ContactSlugEnum.Country: {
          return {
            ...obj,
            [ContactSlugEnum.Country]: obj[ContactSlugEnum.Country]
              ? [...obj[ContactSlugEnum.Country], condition.searchValue as CountryEnum]
              : [condition.searchValue as CountryEnum],
          }
        }
        default: {
          return {
            ...obj,
            [filterFieldItem.slug]: obj[filterFieldItem.slug]
              ? [...obj[filterFieldItem.slug], getDefaultFilterObj(condition)]
              : [getDefaultFilterObj(condition)],
          }
        }
      }
    } else if (Object.keys(ContactSearchFieldEnum).includes(condition.searchField)) {
      const searchField = condition.searchField as keyof typeof ContactSearchFieldEnum
      switch (searchField) {
        case contactAdditionalFilters.last_activity_date: {
          return {
            ...obj,
            [ContactSearchFieldEnum.last_activity_date]: obj[
              ContactSearchFieldEnum.last_activity_date
            ]
              ? [
                  ...obj[ContactSearchFieldEnum.last_activity_date],
                  { searchValue: condition.searchValue },
                ]
              : [{ searchValue: condition.searchValue }],
          }
        }
        case contactAdditionalFilters.affiliate: {
          return {
            ...obj,
            [ContactSearchFieldEnum.affiliate]: obj[ContactSearchFieldEnum.affiliate]
              ? [...obj[ContactSearchFieldEnum.affiliate], { searchValue: condition.searchValue }]
              : [{ searchValue: condition.searchValue }],
          }
        }
        case contactAdditionalFilters.state: {
          return {
            ...obj,
            [ContactSearchFieldEnum.state]: obj[ContactSearchFieldEnum.state]
              ? [
                  ...obj[ContactSearchFieldEnum.state],
                  { searchValue: condition.searchValue as ContactFilterContactStateEnum },
                ]
              : [{ searchValue: condition.searchValue as ContactFilterContactStateEnum }],
          }
        }
        case contactAdditionalFilters.tag: {
          return {
            ...obj,
            [ContactSearchFieldEnum.tag]: obj[ContactSearchFieldEnum.tag]
              ? [...obj[ContactSearchFieldEnum.tag], getDefaultFilterObj(condition)]
              : [getDefaultFilterObj(condition)],
          }
        }
        case contactAdditionalFilters.created_at: {
          return {
            ...obj,
            [ContactSearchFieldEnum.created_at]: obj[ContactSearchFieldEnum.created_at]
              ? [...obj[ContactSearchFieldEnum.created_at], getDefaultFilterObj(condition)]
              : [getDefaultFilterObj(condition)],
          }
        }
        case contactAdditionalFilters.removed_at: {
          return {
            ...obj,
            [ContactSearchFieldEnum.removed_at]: obj[ContactSearchFieldEnum.removed_at]
              ? [...obj[ContactSearchFieldEnum.removed_at], getDefaultFilterObj(condition)]
              : [getDefaultFilterObj(condition)],
          }
        }
        case contactAdditionalFilters.removed_reason_type: {
          return {
            ...obj,
            [ContactSearchFieldEnum.removed_reason_type]: obj[
              ContactSearchFieldEnum.removed_reason_type
            ]
              ? [...obj[ContactSearchFieldEnum.removed_reason_type], getDefaultFilterObj(condition)]
              : [getDefaultFilterObj(condition)],
          }
        }
      }
    }
    return {
      ...obj,
      [condition.searchField]: obj[condition.searchField]
        ? [...obj[condition.searchField], getDefaultFilterObj(condition)]
        : [getDefaultFilterObj(condition)],
    }
  }, {} as ContactFilterType)
}

const getDefaultFilterObj = (
  condition: ContactFilterConditionInterface,
): Omit<ContactFilterConditionInterface, 'searchField'> => ({
  searchValue: condition.searchValue,
  compareOperation: condition.compareOperation,
})
